import type { IconSvgObject } from './types';

const ArrowDownToLineIcon: IconSvgObject = [
  ["path", { d: "M7 12L12 17L17 12M12 16V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 21H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDownToLineIcon;
